import NewPasswordForm from "@/components/auth/NewPasswordForm.tsx";
import ROUTES from "@/config/routes";
import { useSEO } from "@/contexts/SeoContext.tsx";
import RequestClient from "@/data/client";
import { VerifyPasswordTokenUserInputResponse } from "@/types";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function NewPassword() {
  const { setTitle, setDescription } = useSEO();
  const location = useLocation();
  const navigate = useNavigate();
  const [isTokenValid, setIsTokenValid] = useState(false);

  // Extract the token from the URL
  const urlParts = location.pathname.split("/");
  const token = urlParts[urlParts.length - 1];

  useEffect(() => {
    if (token) {
      RequestClient.users.verifyPasswordToken(token)
        .then((response: VerifyPasswordTokenUserInputResponse) => {
          if (response.status === 200) {
            setIsTokenValid(true); // Token is valid
          } else {
            enqueueSnackbar("The token is invalid or has expired", {
              variant: "error",
            });
            navigate(ROUTES.password_expiration);
          }
        })
        .catch(() => {
          enqueueSnackbar("An error occurred while verifying the token", {
            variant: "error",
          });
          navigate(ROUTES.password_expiration);
        });
    } else {
      navigate(ROUTES.password_expiration);
    }
  }, [token, navigate]);

  useEffect(() => {
    setTitle("Reset Password");
    setDescription("Enter your new password");
  }, []);

  return isTokenValid ? <NewPasswordForm /> : null;
}
